import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { headingStyle } from '../../../../../play-core/styles/heading-style';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { randomInRange } from '../../../../../play-core/utils/random';
import { TextPlaceholder } from '../../../components/Placeholder/TextPlaceholder';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { AspectPlaceholder } from '../../../components/Teaser/Placeholder/AspectPlaceholder';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const VideoInfoPlaceholder = ({
  showsSupported
}) => /*#__PURE__*/_jsx(PlayContainer, {
  children: /*#__PURE__*/_jsxs(VideoInformationSection, {
    children: [/*#__PURE__*/_jsxs(VideoDescription, {
      children: [/*#__PURE__*/_jsx(TitlePlaceholder, {
        width: randomInRange(20, 60),
        children: "\xA0"
      }), /*#__PURE__*/_jsx(TextPlaceholder, {
        width: randomInRange(85, 98)
      }), /*#__PURE__*/_jsx(TextPlaceholder, {
        width: randomInRange(85, 98)
      }), /*#__PURE__*/_jsx(TextPlaceholder, {
        width: randomInRange(20, 60)
      })]
    }), showsSupported && /*#__PURE__*/_jsx(AspectPlaceholder, {
      aspectRatio: 16 / 9
    })]
  })
});
const VideoDescription = styled.div.withConfig({
  displayName: "VideoInfoPlaceholder__VideoDescription",
  componentId: "sc-4c45ak-0"
})(["width:100%;"]);
const TitlePlaceholder = styled.div.withConfig({
  displayName: "VideoInfoPlaceholder__TitlePlaceholder",
  componentId: "sc-4c45ak-1"
})(["background-color:", ";width:", "%;transition:width 100ms ease-in-out;", ";", "{margin-top:64px;margin-bottom:8px;}", "{margin-top:56px;margin-bottom:8px;}", "{margin-top:56px;margin-bottom:16px;}"], Colors.GREY_3a3a3a, ({
  width
}) => width, headingStyle, Viewports.for('small'), Viewports.for('mediumUp'), Viewports.for('xLargeUp'));
const VideoInformationSection = styled.section.withConfig({
  displayName: "VideoInfoPlaceholder__VideoInformationSection",
  componentId: "sc-4c45ak-2"
})(["display:grid;grid-auto-flow:row;grid-gap:56px;grid-template-rows:minmax(0,1fr) 90.5px;", "{grid-gap:16px;grid-template-rows:minmax(0,1fr);grid-template-columns:minmax(0,1fr) 298px;margin-top:32px;margin-bottom:48px;}", "{grid-template-columns:minmax(0,1fr) 416px;grid-gap:44px;}"], Viewports.for('largeUp'), Viewports.for('xLargeUp'));